import { createFileRoute, redirect } from '@tanstack/react-router';
import { PLAID_PROCESSOR_TOKEN_BASE_PATH } from '../../../../../../../../features/vendor/plaid/processor-token/plaid-processor-token-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/plaid/')({
  beforeLoad: () => {
    throw redirect({ to: PLAID_PROCESSOR_TOKEN_BASE_PATH });
  },
  preload: false,
});
